'use client';

import React from 'react';
import { useGetTargetStrategyDetailsQuery } from 'src/api/redux';
import { LOCATION } from 'src/hooks/filters/constants';
import useStrategies from 'src/hooks/strategy/useStrategies';
import { getTargetStrategyId } from 'src/utils/strategyHelpers';
import { StrategyEngageBadge, StrategyFreshFacesBadge } from 'src/components/Strategy/shared';

const StrategyCenterSubHeader = () => {
  const { selectedStrategy } = useStrategies(LOCATION.STRATEGY_CENTER);
  const targetStrategyId = getTargetStrategyId(selectedStrategy);
  const hasEngageStrategies =
    selectedStrategy?.engage_strategies &&
    selectedStrategy?.engage_strategies?.length > 0;
  const hasFreshFaces =
    selectedStrategy?.target_strategy?.type === 'FRESH_FACES';

  const { data: strategyDetails, isLoading } = useGetTargetStrategyDetailsQuery(
    targetStrategyId?.toString(),
    { skip: !targetStrategyId }
  );

  const shouldShowContent = selectedStrategy && !isLoading;

  if (!shouldShowContent) {
    return (
      <div className="flex items-center gap-2 text-neutral-500 text-xs">
        <span>Select a strategy to view details</span>
      </div>
    );
  }

  return (
    <div className="flex flex-col gap-4">
      <div className="flex items-center gap-2 text-secondary text-sm font-normal font-['Inter'] leading-tight">
        <span>{strategyDetails?.description || ''}</span>
        {hasFreshFaces && <StrategyFreshFacesBadge />}
        {hasEngageStrategies && <StrategyEngageBadge />}
      </div>
    </div>
  );
};

export default StrategyCenterSubHeader;
